import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Location } from '@remix-run/router'

import { ILocationData } from 'meta/pages/v4/location'
import { useAppSelector } from 'store'
import { LocationSelectors } from 'store/pages/location'

export const useLocationEffect = (callback: (location?: Location) => void) => {
  const location = useLocation()

  useEffect(() => {
    callback(location)
  }, [location, callback])
}

export const useLocationData = ({ idOrCodeUrl }: { idOrCodeUrl: string }): ILocationData | undefined =>
  useAppSelector(LocationSelectors.getLocationData({ idOrCodeUrl }))
